<template>
  <div>
    <div v-for="(obj, index) in ao.types" :key="index">
      <b>{{ obj.type.name }}</b
      >: {{ obj.count }}<br />
    </div>
  </div>
</template>

<script>
export default {
  name: "Ao",
  props: {
    ao: {
      type: Object,
    },
  },
}
</script>
